module.exports = __webpack_public_path__ + "media/images/Twitter-dff2c96e5883255daa1955c3765183c3.png";